import React from 'react'

import * as styles from './ViewFormModal.styles'

export const renderFieldHelpText = (helpText?: string) => {
  if (!helpText) return null
  return <styles.FieldHelpText>{helpText}</styles.FieldHelpText>
}
